import { env, apimKey } from "../../../config";
import log from "../../../utils/log";

export default async function releaseTimeslotAsync({
  slotId,
  queueId,
  serviceType,
}) {
  log("releaseTimeslotAsync", "request", ...arguments);

  const baseUrl = `https://apim-ikeasa.azure-api.net/TMS_ReleaseSlot/${env}/v2/`;
  const response = await fetch(baseUrl, {
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimKey,
    },
    method: "post",
    body: JSON.stringify({
      SlotId: slotId,
      QueueId: queueId,
      ServiceType: serviceType,
    }),
  });

  if (response.status === 200) {
    const json = await response.json();
    log("releaseTimeslotAsync", "response", json);

    return json.timeslots;
  }

  throw new Error(response.status);
}
